// ----------------------------------------------------------------------------
// Component: Promo Cards
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Pagination, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';
import 'snippets/swiper-control/swiper-control';

// Style includes
import './_promo-cards.scss';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--promo-cards';
const CAROUSEL_CLASS = 'carousel--promo-cards';
const CAROUSEL_SECTION_SELECTOR = '.carousel-section--promo-cards';
const CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)?.forEach((element, index) => {
    
    // Generate unique class for each collection list slider
    element.querySelector(CAROUSEL_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-${index}`);
    
    // Generate unique btn classes for slider pagination
    element.querySelector(CAROUSEL_PAGINATION_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-pagination-${index}`);
    // Generate unique btn classes for slider arrows
    element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-btn-prev-${index}`);
    element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-btn-next-${index}`);

    const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
        // Optional parameters
        modules: [Navigation, Pagination, A11y, Keyboard],
        slidesPerView: 1.1,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true,
        breakpoints: {
            // when window width is >= 680px
            680: {
                slidesPerView: 10,
                spaceBetween: 0
            }
        },
        // Pagination
        pagination: {
            el: `.${CAROUSEL_CLASS}-pagination-${index}`,
            type: 'bullets',
            clickable: true,
        },
        // Navigation arrows
        navigation: {
            nextEl: `.${CAROUSEL_CLASS}-btn-next-${index}`,
            prevEl: `.${CAROUSEL_CLASS}-btn-prev-${index}`
        }
    });

    swiper.slides.forEach(function(slide, index) {
        const slideLink = slide.querySelector('a');
        slideLink?.addEventListener('focus', function() {
            swiper.slideTo(index);
        });
    });
});
